import {inject} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {tap} from 'rxjs/operators';

import * as RouterActions from '@app/core/store/router/router.actions';
import {Router} from '@angular/router';
import {UserActionGroup} from "@app/users/store/users.actions";

export const navigateToUsers$ =
  createEffect((actions$ = inject(Actions), router = inject(Router)) =>
      actions$.pipe(
        ofType(RouterActions.NavigateToUsers),
        tap((action) => router.navigate(['users'])
          .then(RouterActions.NavigateToUsersSuccess)),
      ),
    {functional: true}
  );

export const navigateToUsersSuccess$ =
  createEffect((actions$ = inject(Actions)) =>
      actions$.pipe(
        ofType(RouterActions.NavigateToUsersSuccess),
        tap((action) => UserActionGroup.getUsersRequested),
      ),
    {functional: true}
  );
